import storage from "redux-persist/lib/storage";

import { TypedPersistConfig } from "@/types/store";
import type {
  AuthState,
  OnboardState,
  OnboardPropertyState,
} from "@/types/store";

export const authPersistConfig: TypedPersistConfig<AuthState> = {
  key: "auth",
  storage,
};

export const onboardPersistConfig: TypedPersistConfig<OnboardState> = {
  key: "onboard",
  storage,
};

export const onboardPropertyPersistConfig: TypedPersistConfig<OnboardPropertyState> =
  {
    key: "onboardProperty",
    storage,
  };

